export default "__VITE_ASSET__Dhbr2IYn__"